module.exports = __webpack_public_path__ + "35c16db53020a4eda63418f08189bc0a.jpg";